import {Component} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';

export class QuestDescription extends Component {
    static TypeName = 'quest-description';

    @property.string('quest1')
    questID = 'quest1';

    @property.string('Kill 3 green spheres!')
    questDescription = 'Kill 3 green spheres!';

    @property.string('E.Nemy')
    questEnemy = 'E.Nemy';

    @property.int(3)
    questCount = 3;

    @property.int(100)
    questReward = 100;

    @property.int(1)
    questLevel = 1;
}
